<div class="container single-view" id="view-unregistered-user">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/unregistered-users" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'UNREGISTERED_USERS.BTN_BACK_TO_UNREGISTERED_USER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="unregistered-user-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.USER_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                <span data-testid='unregistered-user-name'>
                  @if (unregisteredUser.firstName) {
                    {{ unregisteredUser.firstName | defaultValue }}
                  }
                  @if (unregisteredUser.lastName) {
                    {{unregisteredUser.lastName | defaultValue }}
                  }
                </span>
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyUnregisteredUser) {
              <button data-testid="unregistered-user-edit-btn" class="btn primary-btn" [disabled]="unregisteredUser.isAnonymised" (click)="goToEditUnregisteredUser()">{{ 'UNREGISTERED_USER_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='unregistered-user-delete-btn' id="btn-delete-user" class="btn red-btn" (click)="dialog.show()" [disabled]="unregisteredUser.isAnonymised">{{ 'USERS.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <section class="row">
              <div class="col-12">
                <h4 data-testid="unregistered-user-details">{{ 'UNREGISTERED_USER_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  <dt data-testid="unregistered-user-firstname-label" class="label grid-cols-1 pt-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.FIRST_NAME' | translate }}</dt>
                  <dd data-testid="unregistered-user-firstname" class="value pt-3 pb-3">{{ unregisteredUser.firstName | defaultValue }}</dd>

                  <dt data-testid="unregistered-user-romanisedfirstname-label" class="label grid-cols-1 pt-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.ROMANISED_FIRST_NAME' | translate }}</dt>
                  <dd data-testid="unregistered-user-romanisedfirstname" class="value pt-3 pb-3">{{ unregisteredUser.romanisedFirstName | defaultValue }}</dd>

                  <dt data-testid="unregistered-user-lastname-label" class="label grid-cols-1 pt-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.LAST_NAME' | translate }}</dt>
                  <dd data-testid="unregistered-user-lastname" class="value pt-3 pb-3">{{ unregisteredUser.lastName | defaultValue }}</dd>

                  <dt data-testid="unregistered-user-romanisedlastname-label" class="label grid-cols-1 pt-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.ROMANISED_LAST_NAME' | translate }}</dt>
                  <dd data-testid="unregistered-user-romanisedlastname" class="value pt-3 pb-3">{{ unregisteredUser.romanisedLastName | defaultValue }}</dd>

                  <dt data-testid="unregistered-user-createdon-label" class="label grid-cols-1 pt-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.CREATED_ON' | translate }}</dt>
                  <dd data-testid="unregistered-user-createdon" class="value pt-3 pb-3">{{ unregisteredUser.createdOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</dd>

                  <dt data-testid="unregistered-user-createdby-label" class="label grid-cols-1 pt-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.CREATED_BY' | translate }}</dt>
                  <dd data-testid="unregistered-user-createdby" class="value pt-3 pb-3">{{ unregisteredUser.createdByFullName | defaultValue }}</dd>

                  <dt data-testid="unregistered-user-updatedon-label" class="label grid-cols-1 pt-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.UPDATED_ON' | translate }}</dt>
                  <dd data-testid="unregistered-user-updatedon" class="value pt-3 pb-3">{{ unregisteredUser.updatedOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</dd>

                  <dt data-testid="unregistered-user-updatedby-label" class="label grid-cols-1 pt-3">{{ 'UNREGISTERED_USER_SINGLE_VIEW.UPDATED_BY' | translate }}</dt>
                  <dd data-testid="unregistered-user-updatedby" class="value pt-3 pb-3">{{ unregisteredUser.updatedByFullName | defaultValue }}</dd>
                </dl>
              </div>
            </section>

            <section class="row">
              <div class="col-12 mt-3 mb-3">
                <h4 data-testid="unregistered-user-retailers-details">{{ 'UNREGISTERED_USER_SINGLE_VIEW.UNREGISTERED_USER_RETAILERS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>
              <div class="col-12">
                <p-table [value]="retailersAssignedTo" #dtRetailersAssignedTable>
                  <ng-template #header>
                    <tr>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_NAME' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_CODE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_CITY' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_COUNTRY' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_MARKET' | translate }}</span>
                        </div>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-retailer>
                    <tr>
                      <td>
                        <span class="p-column-title">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_NAME' | translate }}:</span>
                        {{ retailer.name | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'USER_SINGLE_VIEW.TH_CODE' | translate }}:</span>
                        @if (canViewRetailers) {
                          <a [routerLink]="['/retailers/', retailer.id]" class="inline-flex items-center link">{{ retailer.code | defaultValue }}</a>
                        } @else {
                          {{ retailer.code | defaultValue }}
                        }
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_CITY' | translate }}:</span>
                        {{ retailer.city | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_COUNTRY' | translate }}:</span>
                        {{ retailer.isoCountry | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'UNREGISTERED_USER_SINGLE_VIEW.TH_MARKET' | translate }}:</span>
                        {{ retailer.marketName | defaultValue }}
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #emptymessage>
                    <tr>
                      <td colspan="5">{{ 'UNREGISTERED_USER_SINGLE_VIEW.NO_DATA_RETAILERS' | translate }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete unregistered user-->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_USER'" (onClose)="deleteUnregisteredUser($event)"></dialog-reason>
